// {
//   selector: "*[data-tour-step='1']",  CSS selector to pin the popover to
//   description: "",
//   hideArrow: false,                   (optional) Hide arrow on popover
//   hideCurtain: false,                 (optional) Hide curtain behind popover
//   position: "top",                    (optional)
//   popperMods: []                      (optional) Custom popperJS modifiers - https://popper.js.org/docs/v2/modifiers/
//   prev: {                             (optional) Custom options for prev button
//     action: "this.endPrev"                       Route action to custom javascript method
//     toSegment: ""                                Route action to segment
//     label: ""                                    Override the label
//   },
//   next: { ... }
// }

export default {
  domain: {
    url: '/reports_tour',
    steps: [
      {
        selector: "*[data-tour-step='welcome']",
        description:
          '<h3>Hi there!</h3><p>This is an example DMARC report for DOHnuts.com, our fictional (but delicious) donut store. 🍩 It will help you get up to speed with DMARC Digests. Are you ready? Sweet!</p>',
        hideCurtain: true,
        hideArrow: true,
        popperMods: [{ name: 'offset', options: { offset: [0, -10] } }],
      },
      {
        selector: "*[data-tour-step='2']",
        description:
          '<p>These are all the sources that are sending email using your DOHnuts.com domain. They fall into three categories: Known, Unknown, and Forwarded sources.</p>',
      },
      {
        selector: "*[data-tour-step='3']",
        description:
          '<h3><span class="icon icon--non-interactive icon--status-positive"></span> Known sources</h3><p>These are sources that we know belong to you based on the DNS checks we do. Postmark is the email service we use to send DOHnuts’ invoices—and because DKIM, SPF, and DMARC are aligned, it’s considered a healthy source.</p>',
      },
      {
        selector: "*[data-tour-step='4']",
        description:
          '<h3><span class="icon icon--non-interactive icon--status-error"></span> Unknown sources</h3><p>When we can’t verify that a source belongs to you, we mark it as unknown. It’s important to review these thoroughly and...</p><ul class="tour-unknown-list"><li class="donut">If you have control over the source, set up SPF and DKIM.</li><li class="spyglass"> If you don’t recognize the source, it’s possible that they are sending email without your permission.</li></ul><p><a href="https://support.dmarcdigests.com/article/1190-how-to-identify-unknown-sources" target="_blank">Learn about identifying unknown sources &rarr;</a></p>',
      },
      {
        selector: "*[data-tour-step='6']",
        description:
          '<h3><span class="icon icon--non-interactive icon--status-forwarded"></span> Forwarded sources</h3><p>It’s very common for emails to get forwarded. A recipient might forward our donut deals to a friend or set up automatic forwarding for an inbox they no longer use. Forwarded emails often fail authentication checks, but that’s okay. You don’t need to take action on forwarded sources, unless you see a large volume of messages.</p><p><a href="https://support.dmarcdigests.com/article/1195-what-if-dkim-passes-on-a-message-sent-from-an-unknown-source" target="_blank">Learn more &rarr;</a></p>',
      },
      {
        selector: "*[data-tour-step='5']",
        description:
          '<h3><span class="icon icon--non-interactive icon--status-warning"></span> Unhealthy sources</h3><p>This is a known source—our donut shop team is using Gmail to communicate with customers. However, there are alignment issues which caused this source to be marked as unhealthy. Let’s figure out why this source is having DMARC issues and how we can fix them to make sure our emails continue to make it to the inbox. Select this source to continue.</p>',
        next: {
          toSegment: 'source',
        },
      },
    ],
  },
  source: {
    url: '/reports_tour/by_host?host_name=google.com',
    steps: [
      {
        selector: "*[data-tour-step='1']",
        description:
          '<p>On the source overview page you can get detailed insights on how this specific source is performing. It looks like none of the messages sent from this source are DMARC compliant.</p>',
        prev: {
          toSegment: 'domain',
        },
      },
      {
        selector: "*[data-tour-step='2']",
        description:
          '<p>This is the IP addresses that this source is sending from. Let’s dig deeper by selecting the IP.</p>',
        next: {
          toSegment: 'source-ip',
        },
      },
    ],
  },
  'source-ip': {
    url: '/reports_tour/by_address?address_name=127.0.0.1&host_name=google.com',
    steps: [
      {
        selector: "*[data-tour-step='1']",
        description:
          '<p>In the investigate section, we group all related messages based on their From address, authentication results, and alignment.</p>',
        prev: {
          toSegment: 'source',
        },
      },
      {
        selector: "*[data-tour-step='2']",
        description:
          '<h3><span class="auth-status_icon auth-status_icon--interactive auth-status_icon--pass"></span> SPF Result & <span class="auth-status_icon auth-status_icon--interactive auth-status_icon--unaligned"></span> Alignment</h3><p>The SPF check passed, however it’s unaligned because the From address (dohnuts.com) does not match the Return-Path header domain (gmail.com).</p>',
      },
      {
        selector: "*[data-tour-step='3']",
        description:
          '<h3><span class="auth-status_icon auth-status_icon--interactive auth-status_icon--fail"></span> DKIM Result & <span class="auth-status_icon auth-status_icon--interactive auth-status_icon--missing"></span> Alignment</h3><p>The DKIM check failed since no DKIM record was found. And in order for DKIM to be aligned, the DKIM Signature Domain must match the From domain (dohnuts.com).</p>',
      },
      {
        selector: "*[data-tour-step='4']",
        description:
          '<h3>DMARC Compliance</h3><p>Since neither SPF or DKIM are aligned, DMARC is unaligned for this group of messages. A message must have SPF <em>or</em> DKIM alignment in order to be DMARC compliant.</p>',
        popperMods: [{ name: 'offset', options: { offset: [-175, 25] } }],
      },
      {
        selector: "*[data-tour-step='1']",
        description:
          '<p>Select the group to get more detailed information and learn how to fix these issues.</p>',
        next: {
          action: 'this.showInvestigate',
        },
      },
      {
        selector: "*[data-tour-step='5']",
        description:
          '<p>Now we can see actionable steps for achieving DMARC compliance on this source. It looks like all that’s required is a custom Return-Path DNS record so that SPF will align. That’s a piece of cake. 🍰</p>',
        continue: 'this.continueInvestigate',
        hideCurtain: true,
        prev: {
          action: 'this.investigatePrev',
        },
        next: {
          action: 'this.investigateNext',
        },
      },
      {
        selector: "*[data-tour-step='end']",
        description:
          '<p>Thanks for sticking with us this far! We hope this tour was helpful and if you have any questions, please reach out. We recommend checking out our sweet <a href="https://postmarkapp.com/guides/dmarc" target="_blank">DMARC Guide</a> and <a href="https://support.dmarcdigests.com/" target="_blank">help articles</a> for further learning.</p>',
        hideArrow: true,
        hideCurtain: true,
        position: 'bottom',
        prev: {
          action: 'this.endPrev',
        },
        next: {
          action: 'this.endTour',
          label: 'End the tour',
        },
      },
    ],
  },
}
